import Page from "./Page";
import CenterMiddle from "./CenterMiddle";
import Dialog from "./Dialog";
import { ReactNode } from "react";

function ModalDialog(props: {
    title: string;
    closable: boolean;
    centerStyle?: {
        [key: string]: any;
    };
    dialogStyle?: {
        [key: string]: any;
    };
    contentStyle?: {
        [key: string]: any;
    };
    onClose?: () => void;
    children?: ReactNode;
}) {
    return (
        <Page mask={true}>
            <CenterMiddle contentStyle={props.centerStyle}>
                <Dialog title={props.title} closable={props.closable} onClose={props.onClose} style={props.dialogStyle} contentStyle={props.contentStyle}>
                    {props.children}
                </Dialog>
            </CenterMiddle >
        </Page >
    );
}

export default ModalDialog;